/* @flow */
import WizardSteps from './WizardSteps.jsx';

import type { WizardStepNode } from './WizardSteps.jsx';

export type { WizardStepNode };
export default WizardSteps;
